export const environment = {
    serverUrl:"https://uat-ahc.zenzo.in"
}
